import { render, staticRenderFns } from "./Filtration.vue?vue&type=template&id=618a5f7c"
import script from "./Filtration.vue?vue&type=script&lang=js"
export * from "./Filtration.vue?vue&type=script&lang=js"
import style0 from "./Filtration.vue?vue&type=style&index=0&id=618a5f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports